<template>
  <b-modal
    :title="!this.isDetail ? ( this.isEdit ? 'Sửa ' + title : 'Thêm mới ' + title ): 'Chi tiết'"
    @hidden="hideModal"
    centered
    no-close-on-backdrop
    ref="modalCapNhatChucVu"
    size="lg"
    :hide-footer="isDetail"
  >
    <validation-observer ref="observerChucVu">
      <b-form>
        <div class="row">
          <div class="col col-6">
            <validation-provider
              rules="required|maxlength:100"
              :name="type"
              v-slot="validationContext"
            >
              <b-form-group
                class="mb-4"
                id="chucVu-input-group"
                :label="type"
                label-class="required font-weight-bold"
                label-for="chucVu-input"
              >
                <b-form-input
                  :disabled='isDetail'
                  :state="getValidationState(validationContext)"
                  aria-describedby="chucVu-live-feedback"
                  class="border-radius-4"
                  id="chucVu-input"
                  name="chucVu-input"
                  v-model="form.name"
                ></b-form-input>
                <b-form-invalid-feedback id="chucVu-live-feedback"
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col col-6">
            <validation-provider
              rules="required|maxlength:50|code|hashcode"
              name="Mã vị trí"
              v-slot="validationContext"
            >
              <b-form-group
                class="mb-4"
                id="maChucVu-input-group"
                label="Mã vị trí"
                label-class="required font-weight-bold"
                label-for="maChucVu-input"
              >
                <b-form-input
                  :disabled='isDetail'
                  :state="getValidationState(validationContext)"
                  aria-describedby="chucVu-live-feedback"
                  class="border-radius-4"
                  id="maChucVu-input"
                  name="maChucVu-input"
                  v-model="form.codeName"
                ></b-form-input>
                <b-form-invalid-feedback id="chucVu-live-feedback"
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col col-6" v-if="level == 3">
            <validation-provider
              name="Tỉnh/ thành phố"
              rules="required:select"
              v-slot="validationContext"
            >
              <b-form-group
                class="mb-4 required"
                id="idNhomChucVu-input-group"
                label="Tỉnh/ thành phố"
                label-class="required font-weight-bold"
              >
                <v-select
                  :class="
                    selectClass(
                      validationContext.invalid && validationContext.validated
                    )
                  "
                  :options="listParent || []"
                  :reduce="(text) => text.name"
                  :disabled='isDetail'
                  label="name"
                  @input="resetQuanHuyen()"
                  v-model="form.parentTinhThanhName"
                >
                </v-select>
                <b-form-invalid-feedback
                  :force-show="
                    validationContext.invalid && validationContext.validated
                  "
                >
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col col-6" v-if="![0, 1].includes(level) && isShowParent">
            <validation-provider
              :name="level == 2 ? 'Tỉnh/ thành phố' : 'Quận/ huyện'"
              rules="required:select"
              v-slot="validationContext"
            >
              <b-form-group
                class="mb-4 required"
                id="idNhomChucVu-input-group"
                :label="level == 2 ? 'Tỉnh/ thành phố' : 'Quận/ huyện'"
                label-class="required font-weight-bold"
              >
                <v-select
                  :class="
                    selectClass(
                      validationContext.invalid && validationContext.validated
                    )
                  "
                  :options="listParentTinhThanh || listParent || []"
                  :reduce="(text) => text.id"
                  :disabled="!form.parentTinhThanhName && level == 3 || isDetail"
                  label="name"
                  v-model="form.parentId"
                >
                </v-select>
                <b-form-invalid-feedback
                  :force-show="
                    validationContext.invalid && validationContext.validated
                  "
                >
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
        </div>
        <div class="row chon-tinh-thanh" v-if="level == 0 && !this.isDetail">
          <div class="col col-12">
            <div class="d-flex align-items-center mb-3">
              <label class="label-table m-0 flex-1-0 font-weight-bold"
                >Danh sách tỉnh thành trong vùng</label
              >
              <base-button
                class="btn search-information-btn d-block ml-2"
                button="Thêm tỉnh thành"
                color="btn-success"
                @click="moFormThemTinhThanh()"
              >
                Thêm tỉnh thành
              </base-button>
              <base-button
                :disabled="selectedTinhThanh.length === 0"
                class="btn search-information-btn d-block"
                button="Xóa tỉnh thành đã chọn"
                @click="moFormXacNhanXoa()"
              >
                Xóa tỉnh thành đã chọn
              </base-button>
            </div>
            <div class="box-form-result">
              <DataTable
                :value="danhSachTinhThanh"
                :loading="isLoadingTable"
                :selection.sync="selectedTinhThanh"
                :auto-layout="true"
              >
                <Column
                  field="id"
                  headerStyle="width: 40px"
                  header=""
                  bodyStyle="text-align: center"
                  bodyClass="select-column"
                  selectionMode="multiple"
                >
                </Column>
                <Column
                  field="stt"
                  dataKey="stt"
                  headerStyle="width: 40px"
                  headerClass="p-2"
                  header="STT"
                  bodyStyle="text-align: center"
                >
                  <template #filter> </template>
                  <template #body="slotProps">
                    <span>{{ slotProps.index + 1 }}</span>
                  </template>
                </Column>
                <Column
                  filterMatchMode="custom"
                  field="tenTinhThanh"
                  header="Tên tỉnh thành"
                  headerStyle="minWidth: 200px"
                >
                  <template #filter>
                    <InputText
                      type="text"
                      class="p-column-filter"
                      placeholder="Tìm kiếm"
                      v-model="requestForm.name"
                      @change="layDanhSachTinhThanhTrongVung"
                    />
                  </template>
                  <template #body="slotProps">
                    <span>{{ slotProps.data.name }}</span>
                  </template>
                </Column>

                <Column
                  filterMatchMode="custom"
                  field="maViTri"
                  header="Mã vị trí"
                  headerStyle="minWidth: 200px"
                >
                  <template #filter>
                    <InputText
                      type="text"
                      class="p-column-filter"
                      placeholder="Tìm kiếm"
                      v-model="requestForm.codeName"
                      @change="layDanhSachTinhThanhTrongVung"
                    />
                  </template>
                  <template #body="slotProps">
                    <span>{{ slotProps.data.codeName }}</span>
                  </template>
                </Column>
                <Column
                  filterMatchMode="custom"
                  field="thaoTac"
                  header="Thao tác"
                  headerStyle="width: 100px"
                >
                  <template #body="slotProps">
                    <div class="text-center">
                      <font-awesome-icon
                        icon="trash-alt"
                        v-b-popover.hover.top="'Xóa tỉnh thành khỏi vùng'"
                        class="cursor-pointer color-red ml-2"
                        @click="xoaTinhThanhModal(slotProps.data)"
                      />
                    </div>
                  </template>
                </Column>
                <template #empty
                  ><div class="text-center">Không có dữ liệu</div></template
                >
                <template #loading
                  ><div class="text-center">Đang tải dữ liệu ...</div>
                </template>
              </DataTable>
            </div>
          </div>
          <ModalThemTinhThanhVaoVung
            ref="modalThemTinhThanhVaoVung"
            @themTinhThanh="themTinhThanh"
            :idsTinhThanhTrongVung="danhSachTinhThanh.map((x) => x.id)"
            :idsAppend="deletedTinhThanh.map((x) => x.id)"
          ></ModalThemTinhThanhVaoVung>
          <ModalConfirmTitle
            ref="modalTinhThanh"
            title="Bạn có muốn xóa tỉnh thành này khỏi vùng?"
            @confirmed="xoaTinhThanh"
          />
        </div>
      </b-form>
    </validation-observer>
    <template v-if="!isDetail" v-slot:modal-footer>
      <div class="d-flex">
        <base-button
          button="Lưu"
          @click="onSubmit()"
          :disabled="isLoading || isLoadingTable"
          class="btn btn-main ml-2"
        >
          {{ isEdit ? "Cập nhật" : "Thêm Mới" }}
        </base-button>
        <base-button button="Đóng" @click="hideModal()" class="btn btn-line">
          {{ BO_QUA_BUTTON_LABEL }}
        </base-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import _cloneDeep from "lodash/cloneDeep";
import { mapGetters } from "vuex";
import { BO_QUA_BUTTON_LABEL, ROUTE_NAME } from "@/constants/constants";
import { showMsgError } from "@/utils/commonUtils";
import ModalThemTinhThanhVaoVung from "@/components/pages/quan-ly-danh-muc/tinh-thanh/ModalThemTinhThanhVaoVung.vue";
import ModalConfirmTitle from "@/components/modal/ModalConfirmTitle";
export default {
  name: "modalCapNhatChucVu",
  components: {
    ModalThemTinhThanhVaoVung,
    ModalConfirmTitle,
  },
  props: {
    data: {
      type: Object,
    },
    type: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    listParent: {
      type: Array,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: 1,
    },
    id: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ROUTE_NAME: ROUTE_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      listParentTinhThanh: null,
      isShowParent: true,
      form: {
        name: "",
        codeName: "",
        level: this.level,
        parentId: null,
        parentTinhThanhName: null,
      },
      isLoading: false,
      isLoadingTable: false,
      selectedTinhThanh: [],
      danhSachTinhThanh: [],
      requestForm: {},
      tinhThanhsDaChon: [],
      titleItemXoa: "",
      deletedTinhThanh: [],
    };
  },
  computed: {
    ...mapGetters({
      danhSachTinhThanhTrongVung: "dmTinhThanh/danhSachTinhThanhTrongVung",
    }),
  },
  created() {
    //this.layDanhSachTinhThanhTrongVung();
  },
  methods: {
    themTinhThanh(data) {
      this.danhSachTinhThanh.push(...data);
    },
    moFormThemTinhThanh() {
      this.$refs.modalThemTinhThanhVaoVung.showModal();
    },
    xoaTinhThanhModal(item) {
      this.tinhThanhsDaChon = [item];
      this.$refs.modalTinhThanh.showModal();
    },
    xoaTinhThanh() {
      if (this.tinhThanhsDaChon && this.tinhThanhsDaChon.length) {
        for (const tinhThanh of this.tinhThanhsDaChon) {
          let item = this.danhSachTinhThanh.find((x) => x.id == tinhThanh.id);
          if (item) {
            let index = this.danhSachTinhThanh.indexOf(item);
            this.danhSachTinhThanh.splice(index, 1);
          }
        }
        this.deletedTinhThanh.push(...this.tinhThanhsDaChon);
      }
      this.selectedTinhThanh = [];
      this.$refs.modalTinhThanh.hideModal();
    },
    moFormXacNhanXoa() {
      this.tinhThanhsDaChon = this.selectedTinhThanh;
      console.log(this.tinhThanhsDaChon);
      this.$refs.modalTinhThanh.showModal();
    },
    resetQuanHuyen() {
      this.form.parentId = null;
    },
    layDanhSachTinhThanhTrongVung() {
      this.isLoadingTable = true;
      this.$store
        .dispatch("dmTinhThanh/layDanhSachTinhThanhTrongVung", {
          ...this.requestForm,
          vungId: this.form.id,
        })
        .then((res) => {
          this.danhSachTinhThanh = res.data.data;
          this.isLoadingTable = false;
        });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    hideModal() {
      this.$refs["modalCapNhatChucVu"].hide();
    },
    showModal() {
      //this.resetForm();
      this.$refs["modalCapNhatChucVu"].show();
    },
    resetForm() {
      this.form = {
        name: "",
        codeName: "",
        level: this.level,
        parentId: null,
        parentTinhThanhName: null,
      };
    },
    resetFormDelay() {
      this.form = {
        name: "",
        codeName: "",
        level: this.level,
        parentId: null,
        parentTinhThanhName: null,
      };
    },
    async onSubmit() {
      const isValid = await this.$refs.observerChucVu.validate();
      this.form.level = this.level;
      const payload = {
        ...this.form,
        tinhThanhIds: this.danhSachTinhThanh.map((x) => x.id),
      };
      if (isValid) {
        this.isLoading = true;
        if (this.isEdit) {
          await this.$store
            .dispatch("dmTinhThanh/suaTinhThanh", {
              data: payload,
              message: this.getMessage(),
              onSuccess: this.hideModal,
            })
            .then(() => {
              this.hideModal();
              this.$emit("refreshData");
              this.isLoading = false;
            })
            .catch((err) => {
              this.isLoading = false;
              if (err) showMsgError(err.data.message);
            });
        } else {
          await this.$store
            .dispatch("dmTinhThanh/themTinhThanh", {
              data: payload,
              message: this.getMessage(),
              onSuccess: this.hideModal,
            })
            .then(() => {
              this.hideModal();
              this.isLoading = false;
              this.$emit("refreshData");
            })
            .catch((err) => {
              this.isLoading = false;
              if (err) showMsgError(err.data.message);
            });
        }
      }
    },
    getMessage() {
      switch (this.level) {
        case 0: {
          return `${this.isEdit ? "Sửa" : "Thêm mới"} vùng thành công`;
        }
        case 1: {
          return `${
            this.isEdit ? "Sửa" : "Thêm mới"
          } tỉnh/ thành phố thành công`;
        }
        case 2: {
          return `${this.isEdit ? "Sửa" : "Thêm mới"} quận/ huyện thành công`;
        }
        case 3: {
          return `${this.isEdit ? "Sửa" : "Thêm mới"} phường/ xã thành công`;
        }
      }
    },
    selectClass(valid) {
      return {
        "select-invalid": valid,
      };
    },
  },
  watch: {
    id: function() {
      if (this.isEdit) {
        this.form = _cloneDeep(this.data);
        this.form.parentTinhThanhName = this.form.parentNameOfParent;
      } else {
        this.resetForm();
      }
      this.layDanhSachTinhThanhTrongVung();
    },
    "form.parentTinhThanhName": async function(val) {
      //this.isShowParent = false
      // Nếu là xã thì load quận huyện
      if (this.level == 3) { 
        const payload = {
          sonlon: this.level,
          Level: 2,
          PageIndex: 1,
          PageSize: 999,
          ParentName: val,
          onSuccess: (data) => {
            this.listParentTinhThanh = data.items;
          },
        };
        await this.$store.dispatch("dmTinhThanh/layDanhSachTinhThanh", payload);
      }
    },
  },
};
</script>
